module.exports = __webpack_public_path__ + "img/sup_withdraw_jeton3.782072b8.jpg";